'use client';

import { CacheKey } from '@eliadmin/core/src/api/constants';
import { fetchProducts } from '@eliadmin/core/src/api/products/product-api';
import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { ProductCard } from '@eliadmin/core/src/components/product/product-card';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export function PersonalizedProductsSelection({
  initialProducts,
  locale,
}: {
  initialProducts: Product[];
  locale: string;
}) {
  const me = useCustomerStore(state => state.me);
  const isInitialized = useCustomerStore(state => state.isInitialized);
  const { data: products = initialProducts } = useQuery({
    queryKey: [CacheKey.PRODUCTS, 'homepage-selection', locale, me?.customer.id ?? 'guest'],
    queryFn: ({ signal }) =>
      fetchProducts({
        locale,
        authToken: me?.authToken,
        signal,
        query: {
          where: { tags: { in: [2] } },
          results: 8,
          tags: false,
        },
      }).then(response => response.data),
    enabled: isInitialized,
    initialData: !me?.authToken ? initialProducts : undefined,
    placeholderData: initialProducts,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const cards = useMemo(() => products.map(product => ({ ...product, tags: [] })), [products]);
  return cards.map(product => <ProductCard key={`product-${product.id}`} product={product} />);
}
